import { formatCurrency, formatCurrencyWithoutRS } from "util/format";
import { UpCircleOutlined, DownCircleOutlined } from "@ant-design/icons";

export const ColumnsIncomeStatement = [
  {
    title: "Cliente",
    dataIndex: "client",
    textWrap: "word-break",
    ellipsis: true,
  },
];
export const ColumnsIncomeStatementExpend = (data) => {
  let months = replaceMonth(data);
  let width = "14%";

  switch (months.length) {
    case 1:
      width = "40%";
      break;
    case 2:
      width = "25%";
      break;
    case 3:
      width = "20%";
      break;
    case 4:
      width = "18%";
      break;
    case 5:
      width = "12%";
      break;
    case 6:
      width = "10%";
      break;
    case 7:
      width = "10%";
      break;
    case 8:
      width = "10%";
      break;
    case 9:
      width = "10%";
      break;
    case 10:
      width = "10%";
      break;
    case 11:
      width = "10%";
      break;
    case 12:
      width = "10%";
      break;
    default:
      break;
  }
  const columns = [];
  columns.push({
    title: <div style={{ textAlign: "center" }}>Grupo</div>,
    dataIndex: "name",
    textWrap: "word-break",
    ellipsis: true,
    width: width,
    fixed: "left",
    responsive: ["sm"],
    render(text, record) {
      let color = record.isDad ? "#BABBC2" : "";
      let margin = record.isDad ? "0px" : "10px";
      let fontWeight = record.isDad ? "bold" : "initial";
      if (record.categoryType == "REVENUE") {
        if (record.isDad) {
          color = "#BABBC2";
        }
      } else {
        if (record.isDad) {
          color = "#BABBC2";
        }
      }
      if (record.mapping && record.mapping.length == 0) {
        color = "#98A5AC";
      }
      if (record.order == 0 || record.order == 9999) {
        color = "#98A5AC";
      }
      let func = record.isDad ? () => {} : record.showDetails;

      return {
        props: {
          style: { background: color },
        },
        children: (
          <div
            style={{
              marginLeft: margin,
              fontWeight: fontWeight,
              cursor: "pointer",
            }}
            onClick={() => func("total", record, "Total")}
          >
            {text}
          </div>
        ),
      };
    },
  });

  if (months) {
    months.forEach((element) => {
      columns.push({
        title: <div style={{ textAlign: "center" }}>{element.name}</div>,
        textWrap: "word-break",
        ellipsis: true,
        responsive: ["sm"],
        children: [
          {
            title: <div style={{ textAlign: "center" }}>Realizado</div>,
            dataIndex: "amount",
            textWrap: "word-break",
            responsive: ["sm"],

            ellipsis: true,
            render(text, record) {
              let value = 0;
              record.amountMonth.forEach((item) => {
                let keyMonth = item.month.substring(0, 3);
                if (keyMonth == element.key) {
                  value = item.profit;
                }
              });

              let color = record.isDad ? "#BABBC2" : "";
              let fontWeight = record.isDad ? "bold" : "initial";
              if (record.categoryType == "REVENUE") {
                if (record.isDad) {
                  color = "#BABBC2";
                }
              } else {
                if (record.isDad) {
                  color = "#BABBC2";
                }
              }
              if (record.mapping && record.mapping.length == 0) {
                color = "#98A5AC";
              }
              if (record.order == 0 || record.order == 9999) {
                color = "#98A5AC";
              }
              let func = record.isDad ? () => {} : record.showDetails;

              return {
                props: {
                  style: { background: color },
                },
                children: (
                  <div
                    style={{
                      textAlign: "end",
                      fontWeight: fontWeight,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      func(getKeyMonth(element.name), record, element.name)
                    }
                  >
                    {formatCurrency(value)}
                  </div>
                ),
              };
            },
          },
          {
            title: <div style={{ textAlign: "center" }}>AV</div>,
            dataIndex: "verticalAnalysis",
            textWrap: "word-break",
            responsive: ["sm"],
            ellipsis: true,
            render(text, record) {
              let color = record.isDad ? "#BABBC2" : "";
              let fontWeight = record.isDad ? "bold" : "initial";
              if (record.categoryType == "REVENUE") {
                if (record.isDad) {
                  color = "#BABBC2";
                }
              } else {
                if (record.isDad) {
                  color = "#BABBC2";
                }
              }
              if (record.mapping && record.mapping.length == 0) {
                color = "#98A5AC";
              }
              if (record.order == 0 || record.order == 9999) {
                color = "#98A5AC";
              }
              let value = 0;
              record.amountMonth.forEach((item) => {
                let keyMonth = item.month.substring(0, 3);
                if (keyMonth == element.key) {
                  value = item.verticalAnalysis;
                }
              });

              return {
                props: {
                  style: { background: color },
                },
                children: (
                  <div
                    style={{
                      textAlign: "end",
                      fontWeight: fontWeight,
                      cursor: "pointer",
                    }}
                  >
                    {formatCurrencyWithoutRS(value) + "%"}
                  </div>
                ),
              };
            },
          },
          {
            title: <div style={{ textAlign: "center" }}>AH</div>,
            dataIndex: "horizontalAnalysis",
            textWrap: "word-break",
            responsive: ["sm"],
            ellipsis: true,
            render(text, record) {
              let color = record.isDad ? "#BABBC2" : "";
              let fontWeight = record.isDad ? "bold" : "initial";
              if (record.categoryType == "REVENUE") {
                if (record.isDad) {
                  color = "#BABBC2";
                }
              } else {
                if (record.isDad) {
                  color = "#BABBC2";
                }
              }
              if (record.mapping && record.mapping.length == 0) {
                color = "#98A5AC";
              }
              if (record.order == 0 || record.order == 9999) {
                color = "#98A5AC";
              }
              let value = 0;

              record.amountMonth.forEach((item) => {
                let keyMonth = item.month.substring(0, 3);
                if (keyMonth == element.key) {
                  value = item.horizontalAnalysis;
                }
              });
              let colorIcon = "green";
              let icon = <UpCircleOutlined />;
              if (value < 0) {
                colorIcon = "red";
                icon = <DownCircleOutlined />;
              }

              return {
                props: {
                  style: { background: color },
                },
                children: (
                  <div
                    style={{
                      textAlign: "end",
                      fontWeight: fontWeight,
                      cursor: "pointer",
                    }}
                  >
                    {formatCurrencyWithoutRS(value) + "%"}{" "}
                    <span style={{ color: colorIcon }}>{icon}</span>
                  </div>
                ),
              };
            },
          },
        ],
      });
    });
  }

  columns.push({
    title: <div style={{ textAlign: "center" }}>Total</div>,
    responsive: ["sm"],

    children: [
      {
        title: "Realizado",
        dataIndex: "amount",
        textWrap: "word-break",
        responsive: ["sm"],
        ellipsis: true,
        render(text, record) {
          let color = record.isDad ? "#BABBC2" : "";
          let fontWeight = record.isDad ? "bold" : "initial";
          if (record.categoryType == "REVENUE") {
            if (record.isDad) {
              color = "#BABBC2";
            }
          } else {
            if (record.isDad) {
              color = "#BABBC2";
            }
          }
          if (record.mapping && record.mapping.length == 0) {
            color = "#98A5AC";
          }
          if (record.order == 0 || record.order == 9999) {
            color = "#98A5AC";
          }
          let func = record.isDad ? () => {} : record.showDetails;

          return {
            props: {
              style: { background: color },
            },
            children: (
              <div
                style={{
                  textAlign: "end",
                  fontWeight: fontWeight,
                  cursor: "pointer",
                }}
                onClick={() => func("total", record, "Total")}
              >
                {formatCurrency(text)}
              </div>
            ),
          };
        },
      },
      /* {
        title: <div style={{ textAlign: "center" }}>AV</div>,
        dataIndex: "verticalAnalysis",
        textWrap: "word-break",
        responsive: ["sm"],
        ellipsis: true,
        render(text, record) {
          let color = record.isDad ? "#BABBC2" : "";
          let fontWeight = record.isDad ? "bold" : "initial";
          if (record.categoryType == "REVENUE") {
            if (record.isDad) {
              color = "#BABBC2";
            }
          } else {
            if (record.isDad) {
              color = "#BABBC2";
            }
          }
          if (record.mapping && record.mapping.length == 0) {
            color = "#98A5AC";
          }
          if (record.order == 0 || record.order == 9999) {
            color = "#98A5AC";
          }
          return {
            props: {
              style: { background: color },
            },
            children: (
              <div
                style={{
                  textAlign: "end",
                  fontWeight: fontWeight,
                  cursor: "pointer",
                }}
              >
                {formatCurrencyWithoutRS(text) + "%"}
              </div>
            ),
          };
        },
      },*/
    ],
  });

  return columns;
};
export const ColumnsIncomeStatementExpendV2 = (start, end) => {
  let months = getMonthNames(start, end);

  let width = "14%";

  switch (months.length) {
    case 1:
      width = "40%";
      break;
    case 2:
      width = "25%";
      break;
    case 3:
      width = "20%";
      break;
    case 4:
      width = "18%";
      break;
    case 5:
      width = "12%";
      break;
    case 6:
      width = "10%";
      break;
    case 7:
      width = "10%";
      break;
    case 8:
      width = "10%";
      break;
    case 9:
      width = "10%";
      break;
    case 10:
      width = "10%";
      break;
    case 11:
      width = "10%";
      break;
    case 12:
      width = "10%";
      break;
    default:
      break;
  }
  const columns = [];
  columns.push({
    title: <div style={{ textAlign: "center" }}>Grupo</div>,
    dataIndex: "grupo",
    textWrap: "word-break",
    ellipsis: true,
    width: width,
    fixed: "left",
    responsive: ["sm"],
    render(text, record) {
      let color = record.type_value == "GROUP" ? "#BABBC2" : "";
      let margin = record.type_value == "GROUP" ? "0px" : "10px";
      let fontWeight = record.type_value == "GROUP" ? "bold" : "initial";

      if (record.is_total) {
        color = "#98A5AC";
      }

      let func = record.type_value == "GROUP" ? () => {} : record.showDetails;

      return {
        props: {
          style: { background: color },
        },
        children: (
          <div
            style={{
              marginLeft: margin,
              fontWeight: fontWeight,
              cursor: "pointer",
            }}
            onClick={() => func("total", record, "Total")}
          >
            {text}
          </div>
        ),
      };
    },
  });

  if (months) {
    months.forEach((element) => {
      columns.push({
        title: (
          <div style={{ textAlign: "center" }}>{replaceMonthV2(element)}</div>
        ),
        textWrap: "word-break",
        ellipsis: true,
        responsive: ["sm"],
        children: [
          {
            title: <div style={{ textAlign: "center" }}>Realizado</div>,
            dataIndex: element,
            textWrap: "word-break",
            responsive: ["sm"],

            ellipsis: true,
            render(text, record) {
              let color = record.type_value == "GROUP" ? "#BABBC2" : "";
              let fontWeight =
                record.type_value == "GROUP" ? "bold" : "initial";
              if (record.is_total) {
                color = "#98A5AC";
              }

              let func =
                record.type_value == "GROUP" ? () => {} : record.showDetails;

              return {
                props: {
                  style: { background: color },
                },
                children: (
                  <div
                    style={{
                      textAlign: "end",
                      fontWeight: fontWeight,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      func(
                        getKeyMonth(replaceMonthV2(element)),
                        record,
                        element
                      )
                    }
                  >
                    {formatCurrency(text)}
                  </div>
                ),
              };
            },
          },
          {
            title: <div style={{ textAlign: "center" }}>AV</div>,
            dataIndex: element + "_av",
            textWrap: "word-break",
            responsive: ["sm"],
            ellipsis: true,
            render(text, record) {
              let color = record.type_value == "GROUP" ? "#BABBC2" : "";
              let fontWeight =
                record.type_value == "GROUP" ? "bold" : "initial";
              if (record.is_total) {
                color = "#98A5AC";
              }

              let colorIcon = "green";
              let icon = <UpCircleOutlined />;
              
              let value = text;
              if (value < 0) {
                colorIcon = "red";
                icon = <DownCircleOutlined />;
              }

              return {
                props: {
                  style: { background: color },
                },
                children: (
                  <div
                    style={{
                      textAlign: "end",
                      fontWeight: fontWeight,
                      cursor: "pointer",
                    }}
                  >
                    {formatCurrencyWithoutRS(value) + "%"}
                  </div>
                ),
              };
            },
          },
          {
            title: <div style={{ textAlign: "center" }}>AH</div>,
            dataIndex: element + "_ah",
            textWrap: "word-break",
            responsive: ["sm"],

            ellipsis: true,
            render(text, record) {
              let color = record.type_value == "GROUP" ? "#BABBC2" : "";
              let fontWeight =
                record.type_value == "GROUP" ? "bold" : "initial";
              if (record.is_total) {
                color = "#98A5AC";
              }

              let colorIcon = "green";
              let icon = <UpCircleOutlined />;
              

              let value = text;
               if (value == -1) {
                value = 0;
              } else {
                value=value * 100
              }
              
              if (record[element] > 0 && value ==0){
                value =100
              }

              if (value < 0) {
                colorIcon = "red";
                icon = <DownCircleOutlined />;
              }
              return {
                props: {
                  style: { background: color },
                },
                children: (
                  <div
                    style={{
                      textAlign: "end",
                      fontWeight: fontWeight,
                      cursor: "pointer",
                    }}
                  >
                    {formatCurrencyWithoutRS(value) + "%"}{" "}
                    <span style={{ color: colorIcon }}>{icon}</span>{" "}
                  </div>
                ),
              };
            },
          },
        ],
      });
    });
  }

  columns.push({
    title: <div style={{ textAlign: "center" }}>Total</div>,
    responsive: ["sm"],

    children: [
      {
        title: "Realizado",
        dataIndex: "total",
        textWrap: "word-break",
        responsive: ["sm"],
        ellipsis: true,
        render(text, record) {
          let color = record.type_value == "GROUP" ? "#BABBC2" : "";
          let fontWeight = record.type_value == "GROUP" ? "bold" : "initial";
          if (record.is_total) {
            color = "#98A5AC";
          }
          let func =
            record.type_value == "GROUP" ? () => {} : record.showDetails;

          return {
            props: {
              style: { background: color },
            },
            children: (
              <div
                style={{
                  textAlign: "end",
                  fontWeight: fontWeight,
                  cursor: "pointer",
                }}
                onClick={() => func("total", record, "Total")}
              >
                {formatCurrency(text)}
              </div>
            ),
          };
        },
      },
    ],
  });

  return columns;
};

export const ColumnsIncomeStatementCategoryExpend = (data) => {
  let months = replaceMonth(data);
  let width = "15%";
  if (data.length == 1) {
    width = "15%";
  } else if (data.length == 2) {
    width = "10%";
  } else if (data.length == 3) {
    width = "15%";
  } else if (data.length == 4) {
    width = "15%";
  } else if (data.length == 5) {
    width = "15%";
  } else if (data.length == 6) {
    width = "15%";
  } else if (data.length == 7) {
    width = "15%";
  } else if (data.length == 8) {
    width = "15%";
  } else if (data.length == 9) {
    width = "15%";
  } else if (data.length == 10) {
    width = "15%";
  } else if (data.length == 11) {
    width = "15%";
  } else if (data.length == 12) {
    width = "15%";
  }
  const columns = [];

  columns.push({
    title: "Categoria",
    textWrap: "word-break",
    ellipsis: true,
    dataIndex: "category",
    responsive: ["sm"],

    fixed: "left",
    width: width,
    render: (text) => {
      return <div style={{ marginLeft: "10px" }}>{text}</div>;
    },
  });

  if (months) {
    months.forEach((element) => {
      columns.push({
        title: <div>{element.name}</div>,
        children: [
          {
            title: "Realizado",
            textWrap: "word-break",
            responsive: ["sm"],

            ellipsis: true,
            dataIndex: "amount",
            render(text, record) {
              let value = 0;
              record.amountMonth.forEach((item) => {
                let keyMonth = item.month.substring(0, 3);
                if (keyMonth == element.key) {
                  value = item.profit;
                }
              });
              return (
                <div style={{ marginLeft: "40px" }}>
                  {formatCurrency(value)}
                </div>
              );
            },
          },
          {
            title: "AV",
            dataIndex: "Total",
            textWrap: "word-break",
            responsive: ["sm"],

            ellipsis: true,
          },
          {
            title: "AH",
            dataIndex: "Total",
            textWrap: "word-break",
            responsive: ["sm"],

            ellipsis: true,
          },
        ],
      });
    });
  }

  columns.push({
    title: <div style={{ textAlign: "center" }}>Total</div>,
    children: [
      {
        title: "Realizado",
        dataIndex: "amount",
        textWrap: "word-break",
        responsive: ["sm"],

        ellipsis: true,
        render(text, record) {
          return <div>{formatCurrency(text)}</div>;
        },
      },
      {
        title: "AV",
        dataIndex: "verticalAnalysis",
        textWrap: "word-break",
        ellipsis: true,
      },
      {
        title: "AH",
        dataIndex: "Total",
        responsive: ["sm"],

        textWrap: "word-break",
        ellipsis: true,
      },
    ],
  });

  return columns;
};

export function replaceMonthV2(month) {
  var name = month.trim();
  name = name.replace("janeiro", "Janeiro");
  name = name.replace("fevereiro", "Fevereiro");
  name = name.replace("marco", "Março");
  name = name.replace("abril", "Abril");
  name = name.replace("maio", "Maio");
  name = name.replace("junho", "Junho");
  name = name.replace("julho", "Julho");
  name = name.replace("agosto", "Agosto");
  name = name.replace("setembro", "Setembro");
  name = name.replace("outubro", "Outubro");
  name = name.replace("novembro", "Novembro");
  name = name.replace("dezembro", "Dezembro");

  return name;
}
function replaceMonth(month) {
  const newMonth = [];
  if (month) {
    month.forEach((monthItem) => {
      var name = monthItem.trim();
      name = name.replace("JANUARY", "Janeiro");
      name = name.replace("FEBRUARY", "Fevereiro");
      name = name.replace("MARCH", "Março");
      name = name.replace("APRIL", "Abril");
      name = name.replace("MAY", "Maio");
      name = name.replace("JUNE", "Junho");
      name = name.replace("JULY", "Julho");
      name = name.replace("AUGUST", "Agosto");
      name = name.replace("SEPTEMBER", "Setembro");
      name = name.replace("OCTOBER", "Outubro");
      name = name.replace("NOVEMBER", "Novembro");
      name = name.replace("DECEMBER", "Dezembro");
      let order = 0;
      switch (name) {
        case "Janeiro":
          order = 1;
          break;
        case "Fevereiro":
          order = 2;
          break;
        case "Março":
          order = 3;
          break;
        case "Abril":
          order = 4;
          break;
        case "Maio":
          order = 5;
          break;
        case "Junho":
          order = 6;
          break;
        case "Julho":
          order = 7;
          break;
        case "Agosto":
          order = 8;
          break;
        case "Setembro":
          order = 9;
          break;
        case "Outubro":
          order = 10;
          break;
        case "Novembro":
          order = 11;
          break;
        case "Dezembro":
          order = 12;
          break;

        default:
          break;
      }
      newMonth.push({
        name: name,
        order: order,
        key: monthItem.substring(0, 3),
      });
    });
  }
  let monthOrder = newMonth.sort(compareNumbers);

  return monthOrder;
}
function compareNumbers(a, b) {
  return a.order - b.order;
}

function getKeyMonth(month) {
  let key = 0;
  switch (month) {
    case "Janeiro":
      key = "01";
      break;
    case "Fevereiro":
      key = "02";
      break;
    case "Março":
      key = "03";
      break;
    case "Abril":
      key = "04";
      break;
    case "Maio":
      key = "05";
      break;
    case "Junho":
      key = "06";
      break;
    case "Julho":
      key = "07";
      break;
    case "Agosto":
      key = "08";
      break;
    case "Setembro":
      key = "09";
      break;
    case "Outubro":
      key = "10";
      break;
    case "Novembro":
      key = "11";
      break;
    case "Dezembro":
      key = "12";
      break;

    default:
      key = "total";
      break;
  }

  return key;
}

export function getMonthNames(start, end) {
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split("/").map(Number);
    return new Date(year, month - 1, day);
  };

  const startDate = parseDate(start);
  const endDate = parseDate(end);
  const monthNames = [
    "janeiro",
    "fevereiro",
    "marco",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
  ];
  const result = [];

  let currentDate = startDate;

  while (currentDate <= endDate) {
    const month = currentDate.getMonth();
    result.push(`${monthNames[month]}`);
    currentDate.setMonth(currentDate.getMonth() + 1);
  }

  return result;
}
